import { StatItem } from "../types";

export const StatRow = ({ item }: { item: StatItem }) => {
  return (
    <div className="stat-row">
      <div className="stat-number">{item.value}</div>
      <div className="stat-label">{item.label}</div>
    </div>
  );
};
